(function () {
  function preservePreview() {
    var params = new URLSearchParams(window.location.search);
    var preview = params.get('preview_theme_id');
    if (!preview) return;
    document.querySelectorAll('form.mk-contact-form').forEach(function (form) {
      if (form.getAttribute('data-mk-preview-bound') === 'true') return;
      form.setAttribute('data-mk-preview-bound', 'true');
      form.addEventListener('submit', function () {
        try {
          var url = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
          url.searchParams.set('preview_theme_id', preview);
          form.setAttribute('action', url.pathname + url.search + (url.hash || ''));
        } catch (error) {}
      });
    });
  }

  function bindNudges() {
    document.querySelectorAll('[data-mk-contact-topic]').forEach(function (select) {
      if (select.getAttribute('data-mk-nudge-bound') === 'true') return;
      select.setAttribute('data-mk-nudge-bound', 'true');
      var form = select.closest('form');
      var nudge = form ? form.querySelector('[data-mk-contact-nudge]') : null;
      if (!nudge) return;

      function render() {
        var value = select.value;
        var text = '';
        var href = '';
        var cta = '';
        if (value === 'Partnerships & sponsorships') {
          text = nudge.getAttribute('data-nudge-partnership') || '';
          href = nudge.getAttribute('data-href-partnership') || '';
          cta = nudge.getAttribute('data-cta-partnership') || '';
        } else if (value === 'Fundraising') {
          text = nudge.getAttribute('data-nudge-fundraising') || '';
          href = nudge.getAttribute('data-href-fundraising') || '';
          cta = nudge.getAttribute('data-cta-fundraising') || '';
        } else if (value === 'Volunteering') {
          text = nudge.getAttribute('data-nudge-volunteering') || '';
          href = nudge.getAttribute('data-href-volunteering') || '';
          cta = nudge.getAttribute('data-cta-volunteering') || '';
        } else if (value === 'Donation or receipt') {
          text = nudge.getAttribute('data-nudge-donation') || '';
        }
        nudge.replaceChildren();
        if (!text) {
          nudge.hidden = true;
          return;
        }
        var copy = document.createElement('p');
        copy.textContent = text;
        nudge.appendChild(copy);
        if (href && cta) {
          var link = document.createElement('a');
          link.href = href;
          var label = document.createElement('span');
          label.textContent = cta;
          var arrow = document.createElement('span');
          arrow.className = 'mk-router-arrow';
          arrow.setAttribute('aria-hidden', 'true');
          arrow.textContent = ' →';
          link.appendChild(label);
          link.appendChild(arrow);
          nudge.appendChild(link);
        }
        nudge.hidden = false;
      }

      select.addEventListener('change', render);
      render();
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    preservePreview();
    bindNudges();
    var success = document.querySelector('.mk-form-status--success');
    if (success && typeof success.focus === 'function') success.focus();
  });
})();
